/** Doc keys (UUID or storage path) that should open in WYSIWYG edit mode once after create. */
const pendingEditKeys = new Set<string>()

export function markDocumentForEditOnOpen(documentKey: string | null | undefined): void {
  const key = documentKey?.trim()
  if (key) pendingEditKeys.add(key)
}

export function consumeDocumentEditOnOpen(documentKey: string | null | undefined): boolean {
  const key = documentKey?.trim()
  if (!key || !pendingEditKeys.has(key)) return false
  pendingEditKeys.delete(key)
  return true
}
